export default __webpack_public_path__ + "static/media/crew-07.338508df.svg";